import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import RokuSvgColor from '../assets/roku.svg';

export const RokuColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-roku" className={cx('sdkIcon', className)} size={size} {...props}>
    <RokuSvgColor />
  </LegacyIcon>
);
